import React, { useState } from 'react';
import { KnowledgeBaseArticle, KnowledgeBaseArticleContent } from 'types/KnowledgeBase';
import { ContentParserOptions } from 'utils/contentParser';
import { ArticlePresenterContent } from './ArticlePresenterContent';
import { ArticlePresenterDialog } from './ArticlePresenterDialog';

type ArticlePresenterProps = {
	readed?: boolean;
	article: KnowledgeBaseArticle;
	articleContent: KnowledgeBaseArticleContent;
	options?: {
		disableRating?: boolean;
	};
	contentParserOptions?: ContentParserOptions;
	knowledgeBaseLinkPrefix?: string;
};

export const ArticlePresenter = (props: ArticlePresenterProps) => {
	const { contentParserOptions, knowledgeBaseLinkPrefix, article } = props;
	const [currentArticleId, setCurrentArticleId] = useState<number | null>(null);

	return (
		<>
			<ArticlePresenterDialog
				articleId={currentArticleId}
				visible={Boolean(currentArticleId)}
				onHide={() => {
					setCurrentArticleId(null);
				}}
				contentParserOptions={contentParserOptions}
				knowledgeBaseLinkPrefix={knowledgeBaseLinkPrefix}
			/>
			<ArticlePresenterContent
				{...props}
				showSpecialistsInfo={article.programId !== undefined && article.programId === null}
				contentParserOptions={{
					...(contentParserOptions || {}),
					handlers: {
						onArticleLinkClick: (newArticleId: number) => {
							setCurrentArticleId(newArticleId);
						},
						...(contentParserOptions?.handlers || {}),
					},
				}}
			/>
		</>
	);
};
